export const BASE_URL_DEV = "http://localhost:4000";
// REACT_APP_API_URL bisa di-set saat build (mis. build arg Docker); default tetap API produksi
export const BASE_URL_PROD =
  process.env.REACT_APP_API_URL || "https://v2.api.klinikalaia.id";
